export default __webpack_public_path__ + "static/media/51_4_0.4cab885f.png";